import { IconCheck } from '@madpaws/design-system';
import { Icons, ToastContainer as BaseToastContainer } from 'react-toastify';

import type { ReactElement, ReactNode } from 'react';
import type { IconProps, ToastContainerProps } from 'react-toastify';

// Keeps notifications above the fixed platform header.
const TOAST_STYLE = { zIndex: 10000 };

// Success toasts use the design-system check (styled in pages/global.css); the
// other types keep react-toastify's own icons.
const renderIcon = (props: IconProps): ReactNode => {
  if (props.isLoading) {
    return Icons.spinner();
  }

  switch (props.type) {
    case 'success':
      return <IconCheck size="medium" />;
    case 'error':
      return Icons.error(props);
    case 'info':
      return Icons.info(props);
    case 'warning':
      return Icons.warning(props);
    default:
      return null;
  }
};

export const ToastContainer = (props: ToastContainerProps): ReactElement => (
  <BaseToastContainer
    autoClose={3000}
    draggable
    hideProgressBar
    icon={renderIcon}
    newestOnTop={false}
    position="top-right"
    style={TOAST_STYLE}
    theme="colored"
    {...props}
  />
);
